import { FormatedField } from "../types/fields.types";

export const implementFieldConditions = (field: FormatedField, condition: string) => {
  if (!field.settings.conditions) return false;
  const conditions = field.settings.conditions.map((condition) => condition.name);
  return conditions.includes(condition);
};
